export default {
  cardholder_name: 'Nombre completo',
  cardholder_name_placeholder: 'Nombre en la tarjeta',
  card_number: 'Número de tarjeta',
  card_number_placeholder: '1234 5678 9012 3456',
  expiry: 'Fecha de vencimiento',
  expiry_placeholder: 'MM / AA',
  cvv: 'Código de seguridad',
  cvv_label: 'Código de seguridad (CVC)',
  cvv_placeholder: 'CVC',
  loading: 'Inicializando formulario seguro de tarjeta…',
  sdk_load_failed: 'No se pudo cargar el formulario seguro de tarjeta. Comprueba tu conexión y actualiza la página.',
  errors: {
    number_blank: 'Introduce el número de tu tarjeta.',
    number_invalid: 'Este número de tarjeta no es válido. Revisa los dígitos e inténtalo de nuevo.',
    number_incomplete: 'El número de tarjeta está incompleto.',
    cvv_blank: 'Introduce el código de seguridad del reverso de tu tarjeta.',
    cvv_invalid: 'Este código de seguridad no es válido. Revisa los 3 o 4 dígitos de tu tarjeta.',
    cvv_incomplete: 'Introduce los {{count}} dígitos de tu código de seguridad.',
    expiry_invalid: 'Introduce una fecha de vencimiento válida como MM / AA.',
    expired: 'Esta tarjeta ha caducado. Usa otra tarjeta.',
    name_blank: 'Introduce el nombre exactamente como aparece en tu tarjeta.',
    configuration: 'Los pagos con tarjeta no están disponibles en este momento. Prueba con otro método de pago.',
    generic: 'No pudimos comprobar los datos de tu tarjeta. Inténtalo de nuevo.',
  },
};
